// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"773ba639","390":"c40bdd2b","453":"d6aa05cf","732":"50f29cc6"}[chunkId] + ".chunk.js";
};